import { CSSProperties } from 'react';

/**
 * Props for the Ellipse component.
 */
interface IBallProps {
  /**
   * Additional CSS class names for styling.
   */
  className?: string;
  /**
   * Inline styles for the component.
   */
  style?: CSSProperties;
}

/**
 * -----------------------------------------------------------------------------
 * Renders an ball SVG component.
 */
export function PlayerBall({ className, style }: IBallProps) {
  return (
    <div className={className} style={style}>
      <svg fill="none" viewBox="0 0 61 61" xmlns="http://www.w3.org/2000/svg">
        <circle
          cx="30.5"
          cy="30.5"
          fill="url(#paint0_radial_613_2885)"
          id="Ellipse 4"
          r="30.5"
        />
        <defs>
          <radialGradient
            cx="0"
            cy="0"
            gradientTransform="translate(38.125 17.995) rotate(123.065) scale(41.3678)"
            gradientUnits="userSpaceOnUse"
            id="paint0_radial_613_2885"
            r="1"
          >
            <stop stopColor="white" />
            <stop offset="0.538298" stopColor="#9333EA" />
            <stop offset="0.843189" stopColor="#6B21A8" />
            <stop offset="1" stopColor="#9333EA" />
          </radialGradient>
        </defs>
      </svg>
    </div>
  );
}
